module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/mainBg_2f8d72f463fc6a20f08874c4db3593e9.jpg";